import { inject, Injectable } from '@angular/core';
import { QueryParamStateService } from './query-param-state.service';
import { SidebarService } from '@cumlaude/shared-components-overlays';
import { ChatSidebarComponent, ChatSidebarData } from '../sidebars/chat/chat-sidebar.component';

@Injectable({
	providedIn: 'root',
})
export class AiChatService {
	private readonly qp = inject(QueryParamStateService);
	private readonly sidebarService = inject(SidebarService);

	constructor() {
		this.qp.observe('chat').subscribe((chatId) => {
			if (chatId) {
				this.sidebarService.open<ChatSidebarData>(ChatSidebarComponent, {
					hasBackdrop: false,
					allowMultiple: false,
					data: { chatId, inspect: true },
				});
			}
		});
	}
}
